// TODO: toLocaleString for android. Change android build JavascriptCore to: def jscFlavor = 'org.webkit:android-jsc-intl:+'`
export const formatAmount = (amount: number): string => amount?.toLocaleString()

export const formatName = (name: string): string => name?.trim().toUpperCase()
